"use client";
console.warn("⚠️ Avoid importing components from 'index.js' for better performance. This practice is deprecated and may be removed in the future.");
import * as __Builtin from "./_Builtin/index.js";
export { __Builtin as _Builtin };
export * from "./devlinkContext";
export * from "./interactions";
export * from "./utils";
export * from "./devlink";
export * from "./AiAgents";
export * from "./AiTeamsImpact";
export * from "./AiTeamsImpactLang";
export * from "./BrightHeroLeftPannel";
export * from "./CaseStudies";
export * from "./Closer";
export * from "./CloserLlama";
export * from "./CrmNav";
export * from "./Departments";
export * from "./DepartmentsProjectsTest";
export * from "./DevLinkProvider";
export * from "./Gartner";
export * from "./Hero";
export * from "./HeroEldadVarB";
export * from "./HeroEldadVarC";
export * from "./HeroFu";
export * from "./LHeroHover";
export * from "./LHeroVideos";
export * from "./Logos";
export * from "./LotemHero";
export * from "./Magic";
export * from "./MondayDifference";
export * from "./Products";
export * from "./Security";
export * from "./ShorterHero1";
export * from "./ShorterHero2";
export * from "./Trust";
export * from "./TrustNav";
